// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const CalendarLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M11.23 14.154v-1.538h1.54v1.538h-1.54Zm-4 0v-1.538h1.54v1.538H7.23Zm8 0v-1.538h1.54v1.538h-1.54Zm-4 3.846v-1.538h1.54V18h-1.54Zm-4 0v-1.538h1.54V18H7.23Zm8 0v-1.538h1.54V18h-1.54ZM4 21V5h3.385V2.77H8.46V5h7.155V2.77h1V5H20v16H4Zm1-1h14v-9.384H5V20ZM5 9.615h14V6H5v3.615Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const CalendarLineOffset: IconOffset = {
    vertical: 0, // Store Custom Code
    horizontal: 0, // Store Custom Code
};

export default React.memo(CalendarLine);
